import script from "./ModalPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPrice.vue?vue&type=script&setup=true&lang=js"

import "./ModalPrice.vue?vue&type=style&index=0&id=60b28e20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b28e20"]])

export default __exports__